var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM12.5003 21.3238C17.3734 21.3238 21.3238 17.3734 21.3238 12.5003C21.3238 7.62719 17.3734 3.67676 12.5003 3.67676C7.62719 3.67676 3.67676 7.62719 3.67676 12.5003C3.67676 17.3734 7.62719 21.3238 12.5003 21.3238Z",
    fill: "#C7DDFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.357 0.982198C18.7551 1.57178 20.0294 2.40889 21.1208 3.4484C21.8562 4.14873 21.7054 5.31614 20.9049 5.94089C20.1047 6.56531 18.9597 6.40477 18.1836 5.75064C16.6483 4.45657 14.6654 3.67676 12.5003 3.67676C7.62719 3.67676 3.67676 7.62719 3.67676 12.5003C3.67676 17.3734 7.62719 21.3238 12.5003 21.3238C12.611 21.3238 12.7028 21.4113 12.7053 21.522L12.7425 23.1588C12.7656 24.1739 11.9574 25.0294 10.9498 24.9035C9.45415 24.7166 7.99942 24.26 6.65792 23.5508C4.77256 22.5541 3.17356 21.0916 2.01301 19.3024C0.852462 17.5133 0.168961 15.4569 0.0275241 13.329C-0.113913 11.2011 0.291417 9.07241 1.20496 7.14538C2.1185 5.21836 3.50987 3.5571 5.24673 2.31963C6.98358 1.08216 9.00815 0.30964 11.1279 0.0755424C13.2476 -0.158555 15.3919 0.15356 17.357 0.982198Z",
    fill: "#97BFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.37bb3557d9ab5512257ebc29836fb929.svg";
export { ForwardRef as ReactComponent };